import type { GradeCode } from '~/models/Grade'
import stringUtils from '~/utils/stringUtils'
import { GradeType } from '~/models/GradeType'

const { lastInPath } = stringUtils()

export const GRADE1 = 'aarstrinn1'
export const GRADE2 = 'aarstrinn2'
export const GRADE3 = 'aarstrinn3'
export const GRADE4 = 'aarstrinn4'
export const GRADE5 = 'aarstrinn5'
export const GRADE6 = 'aarstrinn6'
export const GRADE7 = 'aarstrinn7'
export const GRADE8 = 'aarstrinn8'
export const GRADE9 = 'aarstrinn9'
export const GRADE10 = 'aarstrinn10'
export const GRADE11 = 'vg1'
export const GRADE12 = 'vg2'
export const GRADE13 = 'vg3'
export const GRADE_ADULT = 'vok'
export const GRADE_PREP = 'forkurs'

export const gradesSorted: GradeCode[] = [
  GRADE1,
  GRADE2,
  GRADE3,
  GRADE4,
  GRADE5,
  GRADE6,
  GRADE7,
  GRADE8,
  GRADE9,
  GRADE10,
  GRADE11,
  GRADE12,
  GRADE13,
  GRADE_ADULT,
  GRADE_PREP,
]

export const grades1to4: GradeCode[] = [GRADE1, GRADE2, GRADE3, GRADE4]
export const grades5to7: GradeCode[] = [GRADE5, GRADE6, GRADE7]
export const grades8to10: GradeCode[] = [GRADE8, GRADE9, GRADE10]
export const gradesVgs: GradeCode[] = [GRADE11, GRADE12, GRADE13]
export const gradesAdult: GradeCode[] = [GRADE_ADULT]
export const gradesPrep: GradeCode[] = [GRADE_PREP]

export const primaryGrades: GradeCode[] = grades1to4.concat(grades5to7)
export const combinedGrades: GradeCode[] = primaryGrades.concat(grades8to10).concat(gradesVgs)
export const lowerGrades: GradeCode[] = primaryGrades.concat(grades8to10)
export const higherGrades: GradeCode[] = grades8to10.concat(gradesVgs)

export const findGradesByGradeType = (gradeType: GradeType) => {
  switch (gradeType) {
    case GradeType.Grade1To4: return grades1to4
    case GradeType.Grade5To7: return grades5to7
    case GradeType.Grade8To10: return grades8to10
    case GradeType.GradeVgs: return gradesVgs
    case GradeType.GradeAdult: return gradesAdult
    case GradeType.GradePrep: return gradesPrep
    default: return []
  }
}

export const findRelevantGradeType = (grade: GradeCode) => {
  if (grades1to4.includes(grade))
    return GradeType.Grade1To4
  if (grades5to7.includes(grade))
    return GradeType.Grade5To7
  if (grades8to10.includes(grade))
    return GradeType.Grade8To10
  if (gradesVgs.includes(grade))
    return GradeType.GradeVgs
  if (gradesAdult.includes(grade))
    return GradeType.GradeAdult
  if (gradesPrep.includes(grade))
    return GradeType.GradePrep
}

export const sortByGradeIndex = (gradeCodeA: GradeCode | string, gradeCodeB: GradeCode | string): number => {
  return gradesSorted.indexOf(lastInPath<GradeCode>(gradeCodeA)) - gradesSorted.indexOf(lastInPath<GradeCode>(gradeCodeB))
}

export const ageGroupMapping: Record<string, GradeCode[]> = {
  '6-9 år': grades1to4,
  '9-12 år': grades5to7,
  '12-15 år': grades8to10,
}

export const gradeTypeMapping: Record<string, GradeCode[]> = {
  '1-4': grades1to4,
  '5-7': grades5to7,
  '8-10': grades8to10,
  'vgs': gradesVgs,
  'voksen': gradesAdult,
  'forkurs': gradesPrep,
}

export const gradeTypeNames: Record<GradeType, string> = {
  [GradeType.Grade1To4]: '1-4',
  [GradeType.Grade5To7]: '5-7',
  [GradeType.Grade8To10]: '8-10',
  [GradeType.GradeVgs]: 'vgs',
  [GradeType.GradeAdult]: 'voksen',
  [GradeType.GradePrep]: 'forkurs',
}
